import { TABLE_NO_DATA_CELL } from '../constants/data';

const PADDING_DIGITS = 2;
const PADDING_STR = '0';

export const renderTime = (date: string | Date | undefined, defaultValue: string = TABLE_NO_DATA_CELL) => {
  if (!date) return defaultValue;

  const dateObj = new Date(date);
  const hours = String(dateObj.getHours()).padStart(PADDING_DIGITS, PADDING_STR);
  const minutes = String(dateObj.getMinutes()).padStart(PADDING_DIGITS, PADDING_STR);

  return `${hours}:${minutes}`;
};
